import { render, staticRenderFns } from "./RegexAnswer.vue?vue&type=template&id=85b66d6a&"
import script from "./RegexAnswer.vue?vue&type=script&lang=js&"
export * from "./RegexAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports